import { isStringLiteralOfType } from "@mcwd/typescript-type-guards";
import type { AnyFormSettingsKey } from "../../form-settings/form-experience/form-settings-keys.js";

export function getRoiCalcUrlQueryString (formSettingsKey: AnyFormSettingsKey): string | null
{
  return isStringLiteralOfType(formSettingsKey, [ "qx-roi", "mx-roi" ])
    ? document.location.search
    : null;
}
